var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "schedule-container"
  }, [_vm.scope.includes('seller') ? _c('matching-schedule-seller', _vm._b({
    on: {
      "save": function save($event) {
        return _vm.$emit('save');
      },
      "cancel": function cancel($event) {
        return _vm.$emit('cancel');
      },
      "reject": function reject($event) {
        return _vm.$emit('reject');
      }
    }
  }, 'matching-schedule-seller', _vm.$attrs, false)) : _vm.scope.includes('buyer') ? _c('matching-schedule-buyer', _vm._b({
    on: {
      "save": function save($event) {
        return _vm.$emit('save');
      }
    }
  }, 'matching-schedule-buyer', _vm.$attrs, false)) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }